import { Editor } from "@tiptap/react";
import AppButton from "../../../components/AppButton";
import LinkIcon from "@mui/icons-material/Link";

import { buttonSx } from "../EditorToolbar";
import { isValidLinkHref } from "../../utils";
import { useIntl } from "react-intl";

const LinkButton = ({ editor }: { editor: Editor }) => {
  const intl = useIntl();

  const insertLink = () => {
    const url = prompt(intl.formatMessage({ id: "ENTER_URL" }));
    if (url) {
      if (!isValidLinkHref(url)) {
        alert(intl.formatMessage({ id: "INVALID_URL_HTTPS" }));
        return;
      }

      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .run();
    }
  };

  return (
    <AppButton intent="secondary" onClick={insertLink} sx={buttonSx}>
      <LinkIcon />
    </AppButton>
  );
};

export default LinkButton;
